import React, { useRef, useImperativeHandle, forwardRef } from 'react'
import SignatureCanvas from 'react-signature-canvas'

export interface SignaturePadHandle {
  toDataURL: (type?: string, encoderOptions?: number) => string
  isEmpty: () => boolean
  clear: () => void
}

interface SignaturePadProps {
  className?: string
  canvasClassName?: string
  canvasProps?: React.CanvasHTMLAttributes<HTMLCanvasElement>
  onEnd?: () => void
  disabled?: boolean
}

const SignaturePad = forwardRef<SignaturePadHandle, SignaturePadProps>(
  ({ className = '', canvasClassName = 'h-[120px]', canvasProps = {}, onEnd, disabled = false }, ref) => {
    const sigRef = useRef<SignatureCanvas>(null)

    useImperativeHandle(ref, () => ({
      toDataURL: (type?: string, encoderOptions?: number) =>
        sigRef.current?.toDataURL(type, encoderOptions) ?? '',
      isEmpty: () => sigRef.current?.isEmpty() ?? true,
      clear: () => sigRef.current?.clear()
    }), [])

    return (
      <div className={`border border-neutral-300 rounded-lg bg-white overflow-hidden ${disabled ? 'opacity-60' : ''} ${className}`}>
        <div className="px-2 py-1 text-xs text-neutral-500 border-b border-neutral-200 bg-white">Sign here</div>
        <div className={`bg-white ${disabled ? 'pointer-events-none' : ''} ${canvasClassName}`}>
          <SignatureCanvas
            ref={sigRef}
            canvasProps={{
              className: 'w-full h-full touch-none bg-white',
              style: { display: 'block', backgroundColor: '#ffffff' },
              ...canvasProps
            }}
            backgroundColor="#ffffff"
            penColor="#000000"
            minWidth={1}
            maxWidth={3}
            onEnd={disabled ? undefined : onEnd}
          />
        </div>
      </div>
    )
  }
)

SignaturePad.displayName = 'SignaturePad'

export default SignaturePad
